<template>
  <router-link
    tag="li"
    :to="route"
    :class="isActive(route)"
  >
    <div class="name-icon-pair">
      <span class="sidebar-item-name">{{ name }}</span>
      <span
        class="sidebar-item-icon tooltip is-tooltip-right"
        :data-tooltip="name"
      >
        <font-awesome-icon
          :icon="icon"
        />
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'SidebarLink',
  props: {
    // An icon of some description
    icon: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    route: {
      type: [String, Object],
      default: '/'
    }
  },
  methods: {
    isActive (name) {
      const { $route } = this
      return { 'router-link-active': $route.matched.some(n => n.name === name) }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';

.sidebar-item-name {
  flex: 1;
  text-align: left;
  margin-left: 20px;
  line-height: $sidebar-item-height;
  font-size: .7em;
  cursor: pointer;
  color: var(--sidebar-text-color);
}

.sidebar-item-icon {
  margin-left: 0;
  width: $sidebar-icon-width;
  height: $sidebar-item-height;
  line-height: $sidebar-item-height;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  color: var(--sidebar-text-color);
}

.name-icon-pair {
  display: flex;

  &:hover {
    background-color: var(--sidebar-hover-color);
  }
}

.structure-container {

  .name-icon-pair {
    &:after {
      content: '';
      height: $sidebar-item-height;
      border-right: 0;
      // border-left: solid var(--base-blue) 10px;
      border-top: solid transparent $sidebar-item-height/2;
      border-bottom: solid transparent $sidebar-item-height/2;
      border-left: solid var(--sidebar-color) 10px;
      position: absolute;
      right: 0px;
      z-index: -10;
      transition: right .1s;
    }
  }

  .router-link-active {
    .name-icon-pair {
      &:after {
        right: -10px;
      }

      &:hover {
        &:after {
          border-left-color: var(--sidebar-hover-color);
        }
      }
    }
  }

  &.sidebar-closed {
    .name-icon-pair {
      &:after {
        right: 0px;
      }
    }
    .tooltip::before,
    .is-tooltip-right:hover::after {
      display: none;
    }
  }

  &:not(.mini) {
    .tooltip::before,
    .is-tooltip-right:hover::after {
      display: none;
    }
  }
}

@media only screen and (max-width: $break-small) {
  .structure-container {

    .name-icon-pair:after {
      display: none;
    }
  }
}

</style>
